import React, { useMemo } from "react";
import JoditEditor from "jodit-react";

interface TextEditorProps {
  value: string;
  onChange: (name: string, value: string) => void;
  name: string;
  height?: number;
  language?: string;
}

const TextEditor = (props: TextEditorProps) => {
  const { value, onChange, height = 400, language = "en", name } = props;
  const config = useMemo(
    () => ({
      height,
      language,
      placeholder: "",
    }),
    [height, language]
  );

  return (
    <JoditEditor
      value={value}
      config={config}
      onChange={(newValue) => onChange(name, newValue)}
    />
  );
};

export default React.memo(TextEditor);
